import {OrderService, MovieService, RegionService,ErrorHandler,EcomTrackingService, MovieMetaService} from 'hasta-la-vista-middleware-api/service'
export default {

    data(){
        return {
            loading: true,
            movie: {},
            cinema: {},
            order: {},
            toggleDialog:false,
            cancelOrderLoad:false,
            currency: "R"
        }
    },
    
    computed:{

        // ticketsGrouped(){
        //     if(!this.order || !this.order.Tickets) return [];
        //     var tickets = this.order.Tickets.reduce((collection, ticket)=> {
        //         let key = ticket.Description;
        //         collection[key] = collection[key] || {Description:ticket.Description,PriceInCents:ticket.PriceCents,Quantity:0};
        //         collection[key].Quantity ++;
        //         return collection;
        //     }, {});
        //
        //     return tickets;
        // },

        total(){

            var ticketTotal =this.order && this.order.Tickets ? this.order.Tickets.reduce((c, t)=>c+=t.PriceCents,0) : 0
            var ConcessionTotal =this.order && this.order.Concessions ? this.order.Concessions.reduce((c, t)=>c+=(t.PriceInCents * t.Quantity),0) : 0

            var priceFormatted = ((ticketTotal + ConcessionTotal)/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            console.log(this.currency+`${priceFormatted}`)
            return this.currency+`${priceFormatted}`
        },

        bookingDate(){
            return `${this.order.SessionDate.additional.string_long_day_of_week} ${this.order.SessionDate.additional.day}`
        },
        movieStartTime(){
            return `${this.order.SessionDate.additional.no_zero_hour_24}:${this.order.SessionDate.additional.minute}`
        },
        movieEndTime(){
            return this.order.SessionDate.date.add(this.movie.runtime,'minutes').format('h:m:a');
        }
        
    },

    methods:{

        formatVistaTime(VistaDate){
            return `${VistaDate.additional.no_zero_hour_24}:${VistaDate.additional.minute}`
        },
        formatVistaDate(VistaDate){
            return `${VistaDate.additional.string_long_day_of_week} ${VistaDate.additional.day} ${VistaDate.additional.string_long_month}`
        },
        getTicketsGrouped(tickets){
            // console.log(tickets);
            if(!tickets) return [];
            var tickets = tickets.reduce((collection, ticket)=> {
                let key = ticket.Description;
                collection[key] = collection[key] || {Description:ticket.Description,PriceInCents:0,Quantity:0};
                collection[key].Quantity ++;
                collection[key].PriceInCents += ticket.PriceCents;
                return collection;
            }, {});

            return tickets;
        },
        groupConcessions(concessions){
            // console.log('concessions',concessions);
            var c = concessions.map((con)=>{
                var c = Object.assign({},con)
                c.PriceInCents = c.PriceInCents * c.Quantity;
                return c;
            });
            return c
        },
        cancelOrder(){
            ErrorHandler.ignoreNextError();
            this.cancelOrderLoad = true;
            let session = OrderService.pendingSession();
            let result = Promise.resolve(OrderService.cancelOrder()).then((result) => {
                OrderService.clearPendingSessions();
                OrderService.tearDown();
                this.$toaster.show('Your booking was successfully cancelled.', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                this.$router.push('/details/' + session.MovieId);
                this.cancelOrderLoad = false
            }, (e) => {
                let session = OrderService.pendingSession();
                OrderService.tearDown();
                this.$router.push('/details/' + session.MovieId);
            });
        },
        confirmCancelOrder() {
            this.toggleDialog = true
        },
    },

    created(){
        var session = OrderService.pendingSession()

        if (session)
            Promise.all([MovieService.getMovieDetail(session.MovieId), RegionService.getCinema(session.CinemaId), OrderService.getOrder(), MovieMetaService.getMovieMeta()])
                .then(([movie,cinema,order, meta])=> {
                    // this.movie = movie;
                    // this.cinema = cinema;
                    this.order = order;
                    if(meta.extended_regions_data != undefined) {
                        for(let i = 0; i < meta.extended_regions_data.length; i++) {
                            if(meta.extended_regions_data[i] != undefined) {
                                if(meta.extended_regions_data[i].cinema_id == cinema.id) {
                                    this.currency = meta.extended_regions_data[i].currency_symbol
                                }
                            }
                        }
                    }
                    // console.log('order',this.order);
                    this.loading = false;


                })
    },

    mounted(){
        window.scroll({top: 0, left: 0})
    }

} 


// WEBPACK FOOTER //
// ./src/components/booking/check-ticket/check-ticket.js